import { postWithAuth } from '@/lib/httpAdapter';
import OrganizationReq from '@/types/organizationReqType';
import apiUrl from './api';
import headerObject from '@/types/headerObj';

const localHost = apiUrl;
const endPoint = 'fetchOrganization/';
const url = localHost + endPoint;

const fetchOrganization = async (orgReq: OrganizationReq) => {
  try {
    const res = await postWithAuth(url, {
      OrganizationUUID: orgReq.OrganizationUUID,
      OrgName: orgReq.OrgName,
    });

    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

    const text = await res.json();
    const data = JSON.parse(text);
    return data.Org;
  } catch (err) {
    console.error(err);
  }
};

export default fetchOrganization;

export const fetchOrganizationByName = async (orgName: string) => {
  try {
    const res = await postWithAuth(url, {
      OrgName: orgName,
    });

    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

    const text = await res.json();
    const data = JSON.parse(text);
    return data.Org;
  } catch (err) {
    console.error(err);
  }
};

export const fetchOrganizationByUUID = async (
  orgUUID: string,
  headerObj?: headerObject
) => {
  try {
    const res = await postWithAuth(url, {
      OrgUUID: orgUUID,
    });

    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

    const data = await res.json();

    if (typeof data === 'string') {
      return JSON.parse(data);
    }

    if (data?.Error) {
      throw new Error(data?.Error);
    }

    return data;
  } catch (err) {
    console.error(err);
  }
};

export const fetchGitlabGroups = async (
  accessToken: string,
  authUrl?: string
) => {
  // Use proxy for self-hosted GitLab instances to avoid CORS
  const isSelfHosted =
    authUrl && authUrl.trim().length > 0 && authUrl !== 'https://gitlab.com';

  try {
    let response;
    if (isSelfHosted) {
      const proxyUrl = `/api/gitlab/proxy/groups?authUrl=${encodeURIComponent(authUrl)}`;
      response = await fetch(proxyUrl, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
    } else {
      const endpoint = 'https://gitlab.com/api/v4/groups';
      response = await fetch(endpoint, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
    }

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    return await response.json();
  } catch (err) {
    console.error(err);
  }
};
